import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiArrowRight, FiTrendingUp } from "react-icons/fi";

export default function DashboardCard({ title, number = 0, icon, path, subtitle }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(path)}
      className="bg-white border border-slate-200/80 hover:border-indigo-300 rounded-2xl p-6 shadow-xs hover:shadow-md transition-all duration-200 cursor-pointer flex flex-col justify-between group relative overflow-hidden"
    >
      {/* Background soft glow on hover */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-50/50 rounded-full blur-2xl group-hover:bg-indigo-100/50 transition-all pointer-events-none -mr-10 -mt-10" />

      <div>
        <div className="flex items-center justify-between gap-3 mb-4">
          <span className="text-xs font-bold uppercase tracking-wider text-slate-500">
            {t(title)}
          </span>
          <div className="p-3 rounded-2xl bg-indigo-50 text-indigo-600 border border-indigo-100/80 group-hover:bg-indigo-600 group-hover:text-white transition-colors duration-200 shadow-xs flex items-center justify-center shrink-0">
            {icon || <FiTrendingUp size={20} />}
          </div>
        </div>

        <div className="flex items-baseline gap-2">
          <span className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            {number}
          </span>
          <span className="text-xs font-medium text-slate-400">միավոր</span>
        </div>

        {subtitle && (
          <p className="text-xs text-slate-500 mt-1 line-clamp-1">{subtitle}</p>
        )}
      </div>

      <div className="pt-5 mt-5 border-t border-slate-100 flex items-center justify-between text-xs font-semibold text-indigo-600 group-hover:text-indigo-700">
        <span>Դիտել բոլորը</span>
        <FiArrowRight
          size={14}
          className="group-hover:translate-x-1 transition-transform duration-200"
        />
      </div>
    </div>
  );
}
